import axiosInstance  from '../../../services/axiosInstance';


//Login Page
export const requestOtp = async (mobile, reagentCode = null ) => {
    const response = await axiosInstance.post('/sign-up', { mobile, reagent_code: reagentCode });
    return response.data;
};

// Verify OTP Page
export const verifyOtp = async (mobile, otp) => {
    const response = await axiosInstance.post('/sign-in', { mobile, otp });
    return response.data;
};

// Update Profile
export const updateUserProfile = async (request) => {
    const response = await axiosInstance.post('/users/update-profile', request );
    return response.data;
};
export const getStates = async (params = null) => {
    const response = await axiosInstance.get('/locations/states', {params} );
    return response.data;
};
export const getCities = async (params = null) => {
    const response = await axiosInstance.get('/locations/cities', {params} );
    return response.data;
};
